module.exports = __webpack_public_path__ + "static/media/culvers_chicago_22_1.1b664233.png";